// Moved verbatim from `src/hooks/query/useQueryOrganizationTeams.ts` (now a
// shim). `selectedOrganizationIdAtom` moved with it (workspace-owned org
// selection — see LEGACY-ATOM-EXPORTS.md); key const lives in `../contracts`.

import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { QUERY_ORGANIZATION_TEAMS } from '../../contracts';
import { getOrganizationTeams } from '../api/organization';
import { selectedOrganizationIdAtom } from '../atoms/organizationAtoms';

export { QUERY_ORGANIZATION_TEAMS };

export function useQueryOrganizationTeams(enabled = true) {
  const orgId = useAtomValue(selectedOrganizationIdAtom);

  return useQuery({
    queryKey: [QUERY_ORGANIZATION_TEAMS, orgId],
    queryFn: () => getOrganizationTeams(orgId!),
    enabled: enabled && orgId !== null,
    staleTime: 60_000,
  });
}
